import React from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import { Splide, SplideSlide } from '@splidejs/react-splide';

import HomeCampaign from '../../../components/GuestHomePageComponents/HomeCampaign';
import SubscribeCTAButton from '../../../components/GuestHomePageComponents/V2Components/SubscribeCTAButtonV2';
import CampaignStore from '../../../store/CampaignStore';
import { CAROUSEL_CONTENT } from '../CarouselContentV2';
import Slide1 from '../../../assets/GuestHome/Slide1.jpg';
import Slide2 from '../../../assets/GuestHome/Slide2.jpg';
import Slide3 from '../../../assets/GuestHome/Slide3.jpg';

import styles from './css/GuestCarouselContentV2.module.css';


const SLIDE_MAP = [
  Slide1,
  Slide2,
  Slide3,
];


function GuestCarouselContentV2(props) {
  const { allActiveCampaigns, user } = props;
  const { campaignToShowOnHomePage } = CampaignStore;


  return (
    <div className={styles.carouselContainer}>
      <Splide
        autoPlay={true}
        className={styles['main-carousel-home']}
        options={{
          type: 'loop',
          drag: false,
          arrows: true,
          pagination: false,
          lazyLoad: true,
          classes: { track: styles.track },
        }}
      >
        {campaignToShowOnHomePage?.name && <SplideSlide>
          <HomeCampaign
            activeCampaign={campaignToShowOnHomePage}
            allActiveCampaigns={allActiveCampaigns}
            title="NAKED NEWS"
            user={user}
          />
        </SplideSlide>}
        {
          Object.keys(CAROUSEL_CONTENT).map((key, index) =>
            (<SplideSlide key={key}>
              <main className={styles.guestHomeMain} id="guest-home-top" style={{ backgroundImage: `url(${SLIDE_MAP[index]})` }}>
                <div className={styles.guestSectionLeft}>
                  <div>
                    <h1 className={classnames(styles.headerText, styles.biggerText, styles.uppercase)}>
                      {CAROUSEL_CONTENT[key].heading1} <br /> {CAROUSEL_CONTENT[key].heading2}
                    </h1>
                    <p
                      className={
                        classnames(styles.description,
                          { [styles.uppercase]: CAROUSEL_CONTENT[key].uppercase })}
                      style={{ color: CAROUSEL_CONTENT[key].color }}
                    >{CAROUSEL_CONTENT[key].content}</p>
                  </div>
                  <SubscribeCTAButton
                    alignRight={false}
                    classNames={styles.btnCurvedRed}
                    doNotHide={true}
                    link={CAROUSEL_CONTENT[key].ctaLink}
                    title="START WATCHING"
                  />
                </div>
              </main>

            </SplideSlide>))}
      </Splide>
      <div className={styles.contentDescription}>
        <p>
          <b className={styles.uppercase}>The Sexiest Naked reporters from around the world uncover news, sports, pop culture and much more.</b>
          <br />
          While they strip down the facts, they strip down themselves. Enjoy 6 new naked shows a week, plus exclusive access to our archives containing thousands of segments, including our popular Naked News auditions.
        </p>
      </div>
    </div>
  );
}

export default observer(GuestCarouselContentV2);
